import './App.css';
import Navbar from './components/Navbar';
import Projects from './components/Projects';
import DoorLock from './pages/DoorLock';
import ArduinoClock from './pages/ArduinoClock';
import Bqms from './pages/Bqms';
import { Routes, Route } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';

function Landing() {
  return (
    <main className="content">
      <section id="home" className="section section--home">
        <div className="hero-content">
          <h1>Hi I'm SAMAN</h1>
          <p>A creator passionate about Electronic and Web Development</p>
          <a className="hero-btn" href="#projects">View My Work</a>
        </div>
      </section>
      <Projects />
    </main>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__brand">Saman Bandara</div>
      <div className="footer__meta">
        <span>Electronic and Web Development</span>
        <span>© 2026</span>
      </div>
      <div className="footer__social">
        <a
          className="footer__socialLink"
          href="https://www.facebook.com/saman.bandara.10360"
          target="_blank"
          rel="noreferrer"
          aria-label="Facebook"
          title="Facebook"
        >
          <FaFacebookF aria-hidden="true" focusable="false" />
        </a>
        <a
          className="footer__socialLink"
          href="https://www.instagram.com/s_bandara_1"
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram"
          title="Instagram"
        >
          <FaInstagram aria-hidden="true" focusable="false" />
        </a>
        <a
          className="footer__socialLink"
          href="https://www.linkedin.com/in/saman-bandara-6b8043284"
          target="_blank"
          rel="noreferrer"
          aria-label="LinkedIn"
          title="LinkedIn"
        >
          <FaLinkedinIn aria-hidden="true" focusable="false" />
        </a>
        <a
          className="footer__socialLink"
          href="https://wa.me/94714083329"
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp"
          title="WhatsApp"
        >
          <FaWhatsapp aria-hidden="true" focusable="false" />
        </a>
      </div>
      <div className="footer__note">Building reliable systems and playful interfaces.</div>
    </footer>
  );
}

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/projects/door-lock" element={<DoorLock />} />
        <Route path="/projects/arduino-clock" element={<ArduinoClock />} />
        <Route path="/projects/bank-queue" element={<Bqms />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
